import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import axios from 'axios';
import cx from 'classnames';
import Loader from 'components/Loader/Loader';
import API, { BASE_PATH } from 'constants/constants';
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import Tile from 'components/Tile/Tile';
import Page404 from 'pages/Page404/Page404';
import Error from 'pages/Error/Error';
import Back from 'ui/Back/Back';
import {
  useCategoryByIdLazyQuery, useContentByIdQuery,
} from 'generated/graphql';

import s from './CategoryItemPage.module.scss';

const CategoryItemPage = () => {
  const routeMatch = useRouteMatch<{ id: string, alias: string }>();
  const [text, setText] = useState('');
  const { data, loading, error } = useContentByIdQuery({
    variables: {
      lang: ['ru'],
      id: routeMatch.params.id,
    },
  });

  const verify = data?.point?.verify;
  const flow = data?.point?.flowURL;

  const categoryId = data?.point?.service?.content?.category.id;

  const [fetchCategoryById, {
    data: categoryByIdData, error: categoryByIdError, loading: categoryByIdLoading,
  }] = useCategoryByIdLazyQuery();

  if (verify !== undefined && !verify) {
    window.location.href = flow || 'https://www.google.by/';
    return <Loader />;
  }

  useEffect(() => {
    if (categoryId) {
      fetchCategoryById({
        variables: {
          id: categoryId,
          lang: ['ru'],
          offset: 0,
          limit: 5,
        },
      });
    }
  }, [categoryId]);

  if (error?.message.includes('invalid syntax')
        || error?.message.includes('bad key')) return <Page404 />;

  if (error || categoryByIdError) return <Error />;

  if (loading || categoryByIdLoading) {
    return <Loader />;
  }

  const getContentText = (link: string | undefined, type: string | undefined) => {
    if (link && ((type === 'html' || type === 'sf_section'))) {
      axios.get(`${BASE_PATH}/gate/p/${link}`)
        .then((res) => {
          if (res.data) {
            setText(res.data);
          }
        })
        .catch(() => {});
    }
  };
  getContentText(data?.point?.service?.content?.link, data?.point?.service.content?.type);

  const content = (data?.point?.service.content?.type === 'html'
        || data?.point?.service.content?.type === 'sf_section')
    ? (
      <div className={s.CategoryItemTextSection}>
        <Back />
        <div className={s.CategoryItemTextTitle}>
          {data?.point?.service.content?.name}
        </div>
        <div className={s.CategoryItemText} dangerouslySetInnerHTML={{ __html: text }} />
      </div>

    )
    : (
      <div className={s.CategoryItemVideo}>
        <Back />
        <div className={s.CategoryItemVideoTitle}>
          {data?.point?.service.content?.name}
        </div>
        <VideoPlayer src={`${API.CONTENT}${data?.point?.service.content?.link}`} />
      </div>
    );

  return (
    <>
      {verify && data
            && (
            <>
              <div className={cx(s.CategoryItemPage)}>
                {content}
                <div className={s.CategoryItemSidebar}>
                  <div className={s.CategoryItemSidebarScrolled}>
                    <div className={s.CategoryItemSidebarWrapper}>
                      {categoryByIdData?.point?.service.category?.contents?.slice(0, 5)
                        .map((item, index) => (
                          <Tile
                            data={item}
                            alias={routeMatch.params.alias}
                            key={item.id}
                            index={index}
                          />
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
            )}
    </>
  );
};

export default CategoryItemPage;
